import { passCodes } from '../passCodes';
import track27 from '../../../../assets/audio/tracks/track27.mp3';

const hints = [
    {
        text: 'Jedná se o jednoho vodního ptáka a jednoho létavého, oba dva jsou bílí.',
    },
    {
        text: 'Kódem je: holubice nebo labuť',
        solution: true,
    },
];
export const step27butchers = {
    id: 25,
    title: '12. stanoviště',
    taskText: `
        <p>
            Mňam, a už jsme tu. Tady jsou na mě vždycky děsně milí. Koukej a hned tu vedle jsou zobrazený další dva ptáci. 
        </p>
    `,
    audio: track27,
    snowAudio: track27,
    catImage: 5,
    cipher: {
        label: 'Úkol',
        text: 'Zadejte jméno alespoň jednoho ptáka, kterého na soše vidíte.',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[18],
    hints: hints,
    snowHints: hints,
};
